<div>
    <div  class="modal-content modal-milvus">
        <div class="modal-header">
            <h6 class="modal-title" id="modal-title-default" >{{'SUGESTAO_DE_TEXTO' | translate}}</h6>
            <button type="button" class="close" (click)="activeModal.close()" style="z-index: 999999999 !important">
                <i class="mdi mdi-close"></i>
            </button>
        </div>

        <div [hidden]="isLoading || apenasLoading">
            <div class="modal-body">
                <div class="form-group">
                    <div [innerHTML]="textoSugerido"></div>
                </div>
            </div>

            <div class="modal-footer modal-footer-milvus">
                <button class="btn badge-pill btn-danger" (click)="close('nao_corrigir')" container=".modal" ngbTooltip="{{ 'TOOLTIP_NAO_CORRIGIR_SUGESTAO' | translate }}">
                    {{'NAO_CORRIGIR' | translate}}
                </button>
                <button class="btn btn-darkblue badge-pill" (click)="close('corrigir')" container=".modal" ngbTooltip="{{ 'TOOLTIP_CORRIGIR_SUGESTAO' | translate }}">
                    {{'CORRIGIR' | translate}}
                </button>
                <button class="btn badge-pill btn-success" style="margin-right: 5px;" (click)="close('aceitar_sugestao')" container=".modal" ngbTooltip="{{ 'TOOLTIP_ACEITAR_SUGESTAO' | translate }}">
                    {{'ACEITAR_SUGESTAO' | translate}}
                </button>
            </div>
        </div>

        <!-- loading ai-->
        <div [hidden]="!isLoading && !apenasLoading">
            <div class="modal-body">
                <div class="form-group">
                    <ngx-spinner
                        name="spinner-ai"
                        bdColor="rgba(0, 0, 0, 0)"
                        template="<img width='200' src='assets/img/brand/Gif_loading_AI.gif' />"
                    ></ngx-spinner>
                    <h1 class="loading-ai-description">
                        {{'LOADING_MILVUS_AI' | translate}}
                    </h1>
                </div>
            </div>
        </div>
    </div>
</div>